import React from 'react';
import { StompingStats } from './types';

const StompingStatsComponent: React.FC<{ stats: StompingStats[] }> = ({
  stats
}) => {
  return (
    <div className='card'>
      <div className='card-body'>
        <h5 className='card-title'>Stomping Statistics</h5>
        <div className='card-text'>
          <table className='table table-bordered'>
            <tbody>
              <tr>
                <th scope='row'>Leg</th>
                {stats.map(s => (
                  <td key={s.leg}>{s.leg}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Sessions</th>
                {stats.map(s => (
                  <td key={s.leg}>{s.sessions.toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Average Score</th>
                {stats.map(s => (
                  <td key={s.leg}>{(s.averageScore || 0).toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Max Score</th>
                {stats.map(s => (
                  <td key={s.leg}>{(s.maxScore || 0).toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Stomps</th>
                {stats.map(s => (
                  <td key={s.leg}>{s.stomps.toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Average Stomp Time</th>
                {stats.map(s => (
                  <td key={s.leg}>{(s.avgStompTime || 0).toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Average Raise Time</th>
                {stats.map(s => (
                  <td key={s.leg}>{(s.avgRaiseTime || 0).toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Average Foot Distance</th>
                {stats.map(s => (
                  <td key={s.leg}>
                    {(s.avgFootDistance || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Average Knee Distance</th>
                {stats.map(s => (
                  <td key={s.leg}>
                    {(s.avgKneeDistance || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export { StompingStatsComponent };
